import { FetchQueryOptions } from "@tanstack/query-core";
import { PaginatedResponse } from "./common";
import { MutationOptions } from "@tanstack/react-query";

export enum HttpMethod {
  Get = "GET",
  Post = "POST",
  Delete = "DELETE",
  Patch = "PATCH",
  Put = "PUT",
}

export enum RequestType {
  Query = "query",
  Mutation = "mutation",
}

export interface ApiFunctions {
  request: <T>(
    url: string,
    method?: HttpMethod,
    body?: any,
    options?: FetchQueryOptions<T> & { requestType?: RequestType }
  ) => Promise<T>;
  get: <T>(url: string, options?: FetchQueryOptions<T>) => Promise<T>;
  delete: (url: string, options?: MutationOptions<void>) => Promise<void>;
  create: <T>(
    url: string,
    body: any,
    options?: MutationOptions<T>
  ) => Promise<T>;
  update: <T>(
    url: string,
    body: any,
    options?: MutationOptions<T>
  ) => Promise<T>;
  set: <T>(url: string, body: any, options?: MutationOptions<T>) => Promise<T>;
  getAll: <T>(
    url: string,
    options?: FetchQueryOptions<PaginatedResponse<T>>
  ) => Promise<PaginatedResponse<T>>;
  batchCreate: <T>(
    url: string,
    body: any,
    options?: MutationOptions<T>
  ) => Promise<T>;
  batchGet: <T>(
    url: string,
    body: any,
    options?: FetchQueryOptions<PaginatedResponse<T>>
  ) => Promise<PaginatedResponse<T>>;
  batchUpdate: <T>(
    url: string,
    body: any,
    options?: MutationOptions<T>
  ) => Promise<T>;
  batchDelete: (
    url: string,
    body: any,
    options?: MutationOptions<void>
  ) => Promise<void>;
}
